import type { RootState } from "store/reducers/main";
import { QuestionType, RegFieldsEnum } from "types/working-model";

export const selectRegistrationQuestions = (state: RootState) => {
	return state.RegistrationQuestionsReducer.registrationQuestions;
};

export const selectRegistrationQuestionsLoading = (state: RootState) => {
	return state.RegistrationQuestionsReducer.loading;
};

export const selectRegistrationQuestionsError = (state: RootState) => {
	return state.RegistrationQuestionsReducer.errorLoading;
};

export const selectTextRegQuestions = (state: RootState) => {
	return state.RegistrationQuestionsReducer.registrationQuestions.filter(q => {
		return q.type === QuestionType.text;
	});
};

export const selectSSOMappableRegQuestions = (state: RootState) => {
	return state.RegistrationQuestionsReducer.registrationQuestions.filter(q => {
		return (
			// only text and checkbox types
			(q.type === QuestionType.text || q.type === QuestionType.checkbox)
			// must not be name or email
			&& q.registration_question > RegFieldsEnum.email
			// must not be passcode
			&& q.registration_question !== RegFieldsEnum.passcode
		);
	});
};